import topic from '../topic'
export const msinAPI = {
    getMsins: topic.msinTopic + '/get_msins',
    getMsinById: topic.msinTopic + '/get_msin_by_id',
    addMsin: topic.msinTopic + '/add_msin',
    editMsin: topic.msinTopic + '/edit_msin',
    deleteMsinByIds: topic.msinTopic + '/delete_msin_by_ids'
}